<div id="participant-list">
  <div *ngIf="isAlone && !!activeRoomName">
    <p class="text-center">Waiting...</p>
  </div>
  <div #list></div>
</div>
